import React, { FC } from "react";
import { ReactComponent as FilmmakersProfileIcon } from "component-library/src/images/svg/filmmakers-profile.svg";
import LogoBaseLink from "./LogoBaseLink";

const FilmmakersProfileWebsiteLogoLink: FC<
  React.PropsWithChildren<{
    href: string;
    tabIndex: number;
  }>
> = ({ href, tabIndex }) => {
  return (
    <LogoBaseLink href={href} tabIndex={tabIndex}>
      <FilmmakersProfileIcon />
    </LogoBaseLink>
  );
};

export default FilmmakersProfileWebsiteLogoLink;
